<template>
  <div id="data-view">
    <dv-full-screen-container>
      <Loading :show="showLoading"></Loading>
      <div class="main-header">
        <div class="main-header_bd">
          <div class="mh-left">
            <!-- 卫生健康政府采购管理平台 -->
          </div>
          <div class="mh-middle">
            <h2 class="title">设备运行状态分析</h2>
            <div class="current-date">
              {{ $format(new Date(), 'YYYY年MM月DD日 HH:mm') }}
            </div>
          </div>
          <div class="mh-right">
			<el-select
			  v-model="getDataParams.orgCode"
			  size="small"
			  style="margin-right: 10px;"
			  placeholder="请选择医疗机构"
			>
			  <el-option
			    v-for="(item, index) in orginfo"
			    :key="'orginfo' + index"
			    :label="item.name"
			    :value="item.code"
			  >
			  </el-option>
			</el-select>
			
            <el-date-picker
              v-model="selectedDate"
              type="monthrange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              prefix-icon="none"
              value-format="yyyyMM"
              size="small"
              @change="changeDate"
            >
            </el-date-picker>
            <el-button
              class="b-ml-10"
              type="primary"
              size="small"
              @click="getAllData"
            >
              查询
            </el-button>
            <dv-border-box-2 class="changeFullScreenBtn">
              <span @click="changeFullScreen">
                {{ isFullScreen ? '退出全屏' : '进入全屏' }}
              </span>
            </dv-border-box-2>
          </div>
        </div>
      </div>

      <dv-border-box-1 class="main-container">
        <dv-border-box-8 class="left-chart-container">
          <Left-Chart-1 :date="getDataParams" ref="left1" />
          <Left-Chart-2 :date="getDataParams" ref="left2" />
          <!-- <Left-Chart-3 :date="getDataParams" ref="left3" /> -->
        </dv-border-box-8>
        <dv-border-box-8 class="center-chart-container">
          <Center-Cmp :date="getDataParams" ref="centerMap" />
          <Center-Bottom :date="getDataParams" ref="centerBottom" />
        </dv-border-box-8>
        <dv-border-box-8 class="right-main-container">
          <Right-Chart-1 :date="getDataParams" ref="right1" />
          <Right-Chart-2 :date="getDataParams" ref="right2" />
          <!-- <Right-Chart-3 :date="getDataParams" ref="right3" /> -->
        </dv-border-box-8>
      </dv-border-box-1>
    </dv-full-screen-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
	
import screenfull from 'screenfull'
import Loading from '../component/Loaidng'

import LeftChart1 from './LeftChart1'
import LeftChart2 from './LeftChart2'
import LeftChart3 from './LeftChart3'

import CenterCmp from './CenterCmp'
import CenterBottom from './CenterBottom'

import RightChart1 from './RightChart1'
import RightChart2 from './RightChart2'
import RightChart3 from './RightChart3'

export default {
  name: 'equipmentRunning',
  components: {
    Loading,
    LeftChart1,
    LeftChart2,
    LeftChart3,
    CenterCmp,
    CenterBottom,
    RightChart1,
    RightChart2,
    RightChart3,
  },
  data() {
    return {
      showLoading: true,
      getDataParams: {
        startdate: '',
        enddate: '',
		orgCode: '',
      },
      selectedDate: [],
	  // orginfo: [],
      isFullScreen: false,
    }
  },
  computed: {
    ...mapState({
      // 行业代码/名称
      // industryinfo: state => state.commonSelectes.industryinfo,
      // 医疗机构
      orginfo: state => state.commonSelectes.orginfo,
      // 药监编码/名称
      // phsinfo: state => state.commonSelectes.phsinfo,
      // 设备分类
      // classInfo: state => state.commonSelectes.classInfo,
    }),
  },
  mounted() {
    setTimeout(() => {
      this.showLoading = false
    }, 3000)
    this.$nextTick(() => {
      screenfull.on('change', () => {
        this.isFullScreen = screenfull.isFullscreen
      })
    })
  },
  methods: {
    changeDate(date) {
      if (date && date.length === 2) {
        this.getDataParams.startdate = date[0]
        this.getDataParams.enddate = date[1]
      } else {
        this.getDataParams.startdate = ''
        this.getDataParams.enddate = ''
      }
    },
    getAllData() {
      this.$refs['left1'].getData()
      this.$refs['left2'].getData()
      this.$refs['left3'].getData()
      this.$refs['centerMap'].getData()
      this.$refs['centerBottom'].getData()
      this.$refs['right1'].getData()
      this.$refs['right2'].getData()
      this.$refs['right3'].getData()
    },
    changeFullScreen() {
      screenfull.toggle()
      // this.isFullScreen ? this.exitFullscreen() : this.enterFullscreen()
      // this.isFullScreen = !this.isFullScreen
    },
  },
}
</script>

<style lang="scss">
#data-view {
  width: 100%;
  height: 100%;
  background-color: #030409;
  color: #fff;

  #dv-full-screen-container {
    background-image: url('../img/bg.png');
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;
  }

  .main-header {
    height: 80px;

    .main-header_bd {
      display: flex;
      height: 110px;
      justify-content: space-between;
      align-items: center;
    }
    .mh-left {
      font-size: 28px;
      font-weight: bold;
      a:visited {
        color: rgb(1, 134, 187);
      }
    }

    .mh-middle {
      text-align: center;
      .title {
        font-size: 48px;
        line-height: 48px;
      }
      .current-date {
        font-size: 24px;
      }
    }

    .mh-right {
      display: flex;
      align-items: center;
      .el-date-editor--monthrange.el-input__inner {
        width: 200px;
      }
      .el-range-input {
        width: 45%;
      }
      .el-range-separator {
        width: 8%;
      }
    }

    .mh-left,
    .mh-right {
      width: 650px;
      .changeFullScreenBtn {
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        margin-left: 20px;
        span {
          cursor: pointer;
          display: block;
        }
      }
    }
  }

  .main-container {
    height: calc(100% - 80px);

    .border-box-content {
      padding: 20px;
      box-sizing: border-box;
      display: flex;
    }
  }

  .left-chart-container {
    width: 30%;
    padding: 10px;
    box-sizing: border-box;

    .border-box-content {
      flex-direction: column;
    }
  }

  .center-chart-container {
    width: 40%;
    .border-box-content {
      flex-direction: column;
    }
  }

  .right-main-container {
    width: 30%;
    padding-left: 5px;
    box-sizing: border-box;
    .border-box-content {
      flex-direction: column;
    }
  }
}
</style>
